import React, { useState, useEffect } from 'react';
import { MdClose, MdLocationOn, MdEdit } from 'react-icons/md';
import axios from 'axios';
import { API_BASE_URL as DEFAULT_API_BASE_URL } from '../../config/api';

const EditZoneModal = ({ isOpen, onClose, zone, showPopup, fetchData, API_BASE_URL, userMmdaId, onSuccess, onError }) => {
  // Use prop API_BASE_URL if provided, otherwise use default from config
  const apiBaseUrl = API_BASE_URL || DEFAULT_API_BASE_URL;
  const [formData, setFormData] = useState({
    zone_name: '',
    description: '',
    status: 'active',
  });
  const [loading, setLoading] = useState(false);

  const config = {
    headers: {
      'Authorization': 'Basic ' + btoa('Techland:Techland@24'),
      'Content-Type': 'application/json',
    },
  };

  useEffect(() => {
    if (isOpen && zone) {
      setFormData({
        zone_name: zone.zone_name || '',
        description: zone.description || '',
        status: zone.status || 'active',
      });
    }
  }, [isOpen, zone]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const updateData = {
        ...formData,
        mmda_id: userMmdaId,
      };

      const response = await axios.put(`${apiBaseUrl}/zones/${zone.zone_id}`, updateData, config);

      if (response.status === 200) {
        fetchData();
        onClose();
        showPopup('Zone updated successfully!', 'success');
      }
    } catch (error) {
      console.error('Error updating zone:', error);
      showPopup('Failed to update zone. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      zone_name: '',
      description: '',
      status: 'active',
    });
    onClose();
  };

  if (!isOpen || !zone) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        width: '90%',
        maxWidth: 500,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid #e0e0e0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdEdit size={24} style={{ color: '#ff9800' }} />
            <h2 style={{ margin: 0, color: '#333', fontSize: 20 }}>Edit Zone</h2>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdClose size={24} style={{ color: '#666' }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{
              display: 'block',
              marginBottom: 5,
              fontWeight: 'bold',
              color: '#333',
              fontSize: 14,
            }}>
              Zone Name *
            </label>
            <input
              type="text"
              name="zone_name"
              value={formData.zone_name}
              onChange={handleInputChange}
              required
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ccc',
                borderRadius: 4,
                fontSize: 14,
                outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>



          <div style={{ marginBottom: 16 }}>
            <label style={{
              display: 'block',
              marginBottom: 5,
              fontWeight: 'bold',
              color: '#333',
              fontSize: 14,
            }}>
              Description
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows={3}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ccc',
                borderRadius: 4,
                fontSize: 14,
                outline: 'none',
                boxSizing: 'border-box',
                resize: 'vertical',
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{
              display: 'block',
              marginBottom: 5,
              fontWeight: 'bold',
              color: '#333',
              fontSize: 14,
            }}>
              Status *
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              required
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ccc',
                borderRadius: 4,
                fontSize: 14,
                outline: 'none',
                boxSizing: 'border-box',
              }}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                padding: '10px 20px',
                border: '1px solid #ccc',
                borderRadius: 4,
                backgroundColor: 'white',
                color: '#333',
                cursor: 'pointer',
                fontSize: 14,
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: 4,
                backgroundColor: loading ? '#ccc' : '#ff9800',
                color: 'white',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: 14,
                fontWeight: 'bold',
              }}
            >
              {loading ? 'Updating...' : 'Update Zone'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditZoneModal;
